import { formatDate } from "../utils/format-utils";
import store from "../store/index";

import Provider from "./Provider";

export default class Assignment {
  assignmentId?: number | null;
  legacyActionId?: number | null;
  servicePlanId?: number | null;
  providerId?: number | null;
  provider?: Provider | null;
  approvalStartDate?: Date | null;
  approvalEndDate?: Date | null;
  startDate?: Date | null;
  endDate?: Date | null;
  providerSpecGroupSize?: number | null;
  providerSpecDurationMinutes?: number | null;
  providerSpecFrequency?: number | null;
  providerSpecLocationId?: number | null;
  providerSpecLocation?: string | null;

  public constructor(params: Assignment = {} as Assignment) {
    let {
      assignmentId = 0,
      legacyActionId = 0,
      servicePlanId = null,
      providerId = null,
      provider = null,
      approvalStartDate = null,
      approvalEndDate = null,
      startDate = null,
      endDate = null,
      providerSpecGroupSize = null,
      providerSpecDurationMinutes = null,
      providerSpecFrequency = null,
      providerSpecLocationId = null,
      providerSpecLocation = null,
    } = params;
    this.assignmentId = assignmentId;
    this.legacyActionId = legacyActionId;
    this.servicePlanId = servicePlanId;
    this.providerId = providerId;
    this.provider = provider && new Provider(provider);
    this.approvalStartDate = approvalStartDate;
    this.approvalEndDate = approvalEndDate;
    this.startDate = startDate;
    this.endDate = endDate;
    this.providerSpecGroupSize = providerSpecGroupSize;
    this.providerSpecDurationMinutes = providerSpecDurationMinutes;
    this.providerSpecFrequency = providerSpecFrequency;
    this.providerSpecLocationId = providerSpecLocationId;
    this.providerSpecLocation = providerSpecLocation;
  }
  get formattedApprovalStartDate() {
    return formatDate(this.approvalStartDate);
  }
  get formattedApprovalEndDate() {
    return formatDate(this.approvalEndDate);
  }
  get formattedStartDate() {
    return formatDate(this.startDate);
  }
  get formattedEndDate() {
    return formatDate(this.endDate);
  }
  get providerName() {
    return this.provider?.firstName + " " + this.provider?.lastName;
  }
  get mandate() {
    if (
      Boolean(this.providerSpecFrequency) &&
      Boolean(this.providerSpecDurationMinutes)
    )
      return (
        this.providerSpecFrequency +
        " x " +
        this.providerSpecDurationMinutes +
        " : " +
        this.providerSpecGroupSize
      );
    return "";
  }
  get semester() {
    return store.getters["optionsModule/getSemesterByDate"](
      this.approvalStartDate
    )?.semesterCode;
  }
}
